import Dialog from '@material-ui/core/Dialog';
import {Row} from '@deere/ux.uxframe-react';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Divider from '@material-ui/core/Divider';
import DialogContent from '@material-ui/core/DialogContent';
import React from 'react';
import {EnvelopeSummaryDocuments} from './EnvelopeSummary/envelopeSummaryDocuments';
import PropTypes from 'prop-types';
import {FormattedMessage} from 'react-intl';

export const DocumentInfoPopup = ({setDocumentInfoPopupStatus, isHidden, documents}) => {

    const handleClose = () => {
        setDocumentInfoPopupStatus(false);
    };

    return (
        <>
            <Dialog aria-labelledby="customized-dialog-title" fullWidth={true} onClose={handleClose} open={isHidden}>
                <Row className="d-flex ml-3 mr-2 mt-2 justify-content-between">
                    <span className="d-inline">
                        <h5 className="font-weight-bold mt-1">
                            <FormattedMessage
                                id={'labels.SELECTED_DOCUMENTS'}/>
                        </h5>
                    </span>

                    <span className="d-inline">
                        <IconButton aria-label="close" onClick={handleClose} size="small">
                            <CloseIcon fontSize="small"/>
                        </IconButton>
                    </span>
                </Row>

                <Divider/>

                <DialogContent>
                    {documents.map(document => (
                        <EnvelopeSummaryDocuments
                            documentName={document.documentDesc}
                            key={document.id}
                        />
                    ))}
                </DialogContent>
            </Dialog>
        </>
    )
};


DocumentInfoPopup.propTypes = {
    setDocumentInfoPopupStatus: PropTypes.func,
    documents: PropTypes.array,
    isHidden: PropTypes.bool
};
